import superjson from 'superjson';
import type { SessionValidationResult, TGetOrganizationSessionResponse } from '@/types/auth';

/**
 * Server-side session validation using API endpoints
 * instead of direct database access.
 */
export async function getSession(request: Request): Promise<SessionValidationResult> {
  try {
    const apiUrl = process.env.BUN_PUBLIC_API_URL;

    // Forward cookies from the original request to the API call
    const response = await fetch(`${apiUrl}/api/auth/session-json`, {
      method: 'GET',
      headers: {
        Cookie: request.headers.get('Cookie') || '',
        'Content-Type': 'application/json',
      },
      credentials: 'include',
    });

    if (!response.ok) {
      console.error('API session validation failed:', response.status, response.statusText);
      return {
        isAuthenticated: false,
        session: null,
        user: null,
      };
    }

    const result = await response.json();

    // The API returns superjson serialized data
    return superjson.deserialize<SessionValidationResult>(result);
  } catch (error) {
    console.error('Server session validation error:', error);
    return {
      isAuthenticated: false,
      session: null,
      user: null,
    };
  }
}

export async function getServerOrganizationSession(
  request: Request,
): Promise<TGetOrganizationSessionResponse | null> {
  try {
    const apiUrl = process.env.BUN_PUBLIC_API_URL;

    // Forward cookies from the original request to the API call
    const response = await fetch(
      `${apiUrl}/api/trpc/organization.getOrganizationSession?input={"json":null,"meta":{"values":["undefined"]}}`,
      {
        method: 'GET',
        headers: {
          Cookie: request.headers.get('Cookie') || '',
          'Content-Type': 'application/json',
        },
        credentials: 'include',
      },
    );

    if (!response.ok) {
      console.error('API organization session fetch failed:', response.status, response.statusText);
      return null;
    }

    const result = await response.json();

    // TRPC returns data in result.result format
    // The API returns superjson serialized data
    return superjson.deserialize<TGetOrganizationSessionResponse>(result.result.data);
  } catch (error) {
    console.error('Server organization session fetch error:', error);
    return null;
  }
}
